import { defineComponent as d, openBlock as t, createElementBlock as l, mergeProps as M, unref as o, renderSlot as p, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, A = { key: 2 }, f = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconTextOutdent"
}, L = /* @__PURE__ */ d({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = i(r);
    return (Z, a) => (t(), l("svg", M({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(s)), [
      p(Z.$slots, "default"),
      o(n) === "bold" ? (t(), l("g", g, a[0] || (a[0] = [
        e("path", { d: "M228,128a12,12,0,0,1-12,12H120a12,12,0,0,1,0-24h96A12,12,0,0,1,228,128ZM120,76h96a12,12,0,0,0,0-24H120a12,12,0,0,0,0,24Zm96,104H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM72,148a12,12,0,0,0,8.49-20.49L49,96,80.49,64.48a12,12,0,0,0-17-17l-40,40a12,12,0,0,0,0,17l40,40A12,12,0,0,0,72,148Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), l("g", m, a[1] || (a[1] = [
        e("path", {
          d: "M216,64V192H40V88L64,64Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), l("g", A, a[2] || (a[2] = [
        e("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,8-8V56a8,8,0,0,0-13.66-5.66l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), l("g", f, a[3] || (a[3] = [
        e("path", { d: "M222,128a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM112,70H216a6,6,0,0,0,0-12H112a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM72,142a6,6,0,0,0,4.24-10.24L40.49,96,76.24,60.24a6,6,0,0,0-8.48-8.48l-40,40a6,6,0,0,0,0,8.48l40,40A6,6,0,0,0,72,142Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), l("g", h, a[4] || (a[4] = [
        e("path", { d: "M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), l("g", k, a[5] || (a[5] = [
        e("path", { d: "M220,128a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM112,68H216a4,4,0,0,0,0-8H112a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM72,140a4,4,0,0,0,2.83-6.83L37.66,96,74.83,58.83a4,4,0,0,0-5.66-5.66l-40,40a4,4,0,0,0,0,5.66l40,40A4,4,0,0,0,72,140Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  L as default
};
